module.exports = __webpack_public_path__ + "static/media/volume-down.51584daa.svg";